<template>
  <v-card flat class="my-2" v-if="hasData">
    <v-form ref="form">
      <v-card-title
          class="py-3 info-block-title">
        <span class="ecdgray--text subtitle-2 text-uppercase subtitle-3">{{ $t("DealDetails") }}</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-row class="info-container body-1 black--text">
          <v-col cols="12" md="4" class="info-block">
            <p class="caption ecgray--text text--darken-2">{{$t('DealDescription')}}</p>
            <v-text-field v-model="invoicingDealDetailsModel.dealDescription"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="info-block">
            <p class="caption ecgray--text text--darken-2">{{$t('CustomerName')}}</p>
            <v-text-field v-model="invoicingDealDetailsModel.consumerName" :rules="[vr.primitives.required]"></v-text-field>
          </v-col>
          <v-col cols="12" md="4" class="info-block">
            <p class="caption ecgray--text text--darken-2">{{$t('NationalID')}}</p>
            <v-text-field v-model="invoicingDealDetailsModel.consumerNationalID" :rules="[vr.special.israeliNationalId]"></v-text-field>
          </v-col>
          <template v-if="editable">
            <v-col cols="12" md="4" class="info-block" v-if="invoicingDealDetailsModel.consumerID">
              <p class="caption ecgray--text text--darken-2">{{$t('Customer')}}</p>
              <template v-if="consumerName">
                {{ invoicingDealDetailsModel.consumerName }}              
              </template>
              <template v-else>              
                {{invoicingDealDetails.consumerID | guid}}
              </template>
            </v-col>
            <v-col cols="12" md="4" class="info-block">
              <p class="caption ecgray--text text--darken-2">{{$t('CustomerEmail')}}</p>
              <v-text-field v-model="invoicingDealDetailsModel.consumerEmail" :rules="[vr.primitives.required, vr.primitives.email]"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="info-block">
              <p class="caption ecgray--text text--darken-2">{{$t('CustomerPhone')}}</p>
              <v-text-field v-model="invoicingDealDetailsModel.consumerPhone"></v-text-field>
            </v-col>
            <v-col cols="12" md="4" class="info-block" v-if="invoicingDealDetailsModel.consumerExternalReference">
              <p class="caption ecgray--text text--darken-2">{{$t('CustomerExternalReference')}}</p>
              <v-text-field v-model="invoicingDealDetailsModel.consumerExternalReference"></v-text-field>
            </v-col>
            <template v-if="hasAddressData || editable">
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('City')}}</p>
                <v-text-field v-model="consumerAddress.city"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('Street')}}</p>
                <v-text-field v-model="consumerAddress.street"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('House')}}</p>
                <v-text-field v-model="consumerAddress.house"></v-text-field>              
              </v-col>
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('Apartment')}}</p>
                <v-text-field v-model="consumerAddress.apartment"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('Zip')}}</p>
                <v-text-field v-model="consumerAddress.zip"></v-text-field>
              </v-col>
            </template>
            <template v-if="invoicingDealDetailsModel.responsiblePerson || invoicingDealDetailsModel.externalUserID">
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('ResponsiblePerson')}}</p>
                <v-text-field v-model="invoicingDealDetailsModel.responsiblePerson"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('ExternalUserID')}}</p>
                <v-text-field v-model="invoicingDealDetailsModel.externalUserID"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('Branch')}}</p>
                <v-text-field v-model="invoicingDealDetailsModel.branch"></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="info-block">
                <p class="caption ecgray--text text--darken-2">{{$t('Department')}}</p>
                <v-text-field v-model="invoicingDealDetailsModel.department"></v-text-field>
              </v-col>
            </template>
          </template>
        </v-row>
        <v-row>
        <v-col cols="12" class="d-flex justify-end">
          <v-btn class="mx-1" color="success" @click="save()" :loading="loading">{{$t("CreateInvoice")}}</v-btn>
        </v-col>
      </v-row>        
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import ValidationRules from "../../helpers/validation-rules";
export default {
  components: {
    InputEditable: () => import('../inputs/InputEditableDealDetails.vue')
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    consumerName: {
      type: String,
      required: false,
      default: null
    }
  },
  model: {
    prop: 'data',
    event: 'update'
  },
  data() {
    return {
      editable: true,
      loading: false,
      model: {
        ...this.data,
        consumerAddress: this.data.consumerAddress || {}
      },      
      vr: ValidationRules,      
    }
  },
  computed: {
    invoicingDealDetailsModel() {
        return this.model.invoicingDealDetails || {};
      }, 
    hasData() {
      return this.invoicingDealDetailsModel.dealDescription || this.invoicingDealDetailsModel.consumerName || this.invoicingDealDetailsModel.consumerNationalID || this.invoicingDealDetailsModel.consumerID || this.invoicingDealDetailsModel.consumerEmail || this.invoicingDealDetailsModel.consumerPhone || this.invoicingDealDetailsModel.consumerExternalReference || this.invoicingDealDetailsModel.consumerAddress || this.invoicingDealDetailsModel.responsiblePerson || this.invoicingDealDetailsModel.externalUserID || this.invoicingDealDetailsModel.branch || this.invoicingDealDetailsModel.department;
    },
    hasAddressData() {
      return this.consumerAddress.street || this.consumerAddress.house || this.consumerAddress.apartment || this.consumerAddress.city || this.consumerAddress.zip;
    },
    consumerAddress() {
      return this.data.consumerAddress || {
        street: '',
        house: '',
        apartment: '',
        city: '',
        zip: '',
      };
    },
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.$emit('ok');
    }
  }  
};
</script>
<style>
.v-input input {
    max-height: 18px;
}
.v-text-field input {
    flex: 1 1 auto;
    line-height: 20px;
    padding: 8px 0;
    max-width: 100%;
    min-width: 0;
    width: 100%;
}
.v-input input {
    max-height: 32px;
    min-height: 22px;
}
</style>